// opervex-frontend/src/Opervex/index.js

import Axios from "./axiosController";

import System from "./System";
import MaterialManagement from "./MaterialManagement";
import Accounting from "./Accounting";
import ServiceManagement from "./ServiceManagement";
import HumanResources from "./HumanResources";
import Sales from "./Sales";
import Tax from "./Tax";
import Unifique from "./Unifique";
import Report from "./Report";
import Dashboard from "./Dashboard";
import Financial from "./Financial";

class Opervex {
  constructor(tenantId = null) {
    this.Axios = new Axios(tenantId);

    this.System = new System(this.Axios);
    this.MaterialManagement = new MaterialManagement(this.Axios);
    this.Accounting = new Accounting(this.Axios);
    this.ServiceManagement = new ServiceManagement(this.Axios);
    this.HumanResources = new HumanResources(this.Axios);
    this.Sales = new Sales(this.Axios);
    this.Tax = new Tax(this.Axios);
    this.Unifique = new Unifique(this.Axios);
    this.Report = new Report(this.Axios);
    this.Dashboard = new Dashboard(this.Axios);
    this.Financial = new Financial(this.Axios);
  }
}

export default Opervex;
